import React from "react";
import { FaEye, FaUser } from "react-icons/fa";

const DetailRow = ({ label, value, action }) => (
  <div className="grid grid-cols-[minmax(110px,0.9fr)_minmax(0,1fr)_auto] items-center gap-3 border-b border-slate-200/80 py-4 last:border-b-0 dark:border-white/10">
    <span className="text-sm font-medium text-slate-600 dark:text-slate-300">{label}</span>
    <span className="min-w-0 break-words text-sm font-semibold text-slate-950 dark:text-white">{value}</span>
    <span>{action}</span>
  </div>
);

export default function ChildPersonalDetails({
  fields,
  title,
  dateBirthLabel,
  dateBirth,
  registrationLabel,
  registrationDate,
}) {
  const bsnField = fields[0];
  const bsnAction = bsnField?.action
    ? React.cloneElement(bsnField.action, {
        className:
          "inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-semibold text-indigo-600 transition hover:bg-indigo-50 hover:text-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-60 dark:text-indigo-300 dark:hover:bg-indigo-950/40 dark:hover:text-indigo-100",
        children: (
          <>
            {bsnField.action.props.children}
            <FaEye aria-hidden="true" />
          </>
        ),
      })
    : null;

  return (
    <section className="rounded-[20px] border border-slate-200/80 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-white/5">
      <div className="mb-3 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 dark:bg-indigo-400/15 dark:text-indigo-200">
          <FaUser aria-hidden="true" />
        </span>
        {title && <h3 className="text-xl font-bold text-slate-950 dark:text-white">{title}</h3>}
      </div>
      <div className="mt-3">
        {bsnField && <DetailRow label={bsnField.label} value={bsnField.value} action={bsnAction} />}
        <DetailRow label={dateBirthLabel} value={dateBirth} />
        <DetailRow label={registrationLabel} value={registrationDate} />
        {fields.slice(1).map((field) => (
          <DetailRow key={field.label} label={field.label} value={field.value} action={field.action} />
        ))}
      </div>
    </section>
  );
}
